import React from "react";
import { useLang } from "../i18n/LanguageContext";
import { Reveal } from "../components/Reveal";
import { PageHero, CtaBand } from "../components/Primitives";
import { IMG } from "../lib/assets";
import { Seo } from "../components/Seo";

export default function Journal() {
  const { t } = useLang();
  const categories = t("journal.categories");
  return (
    <div data-testid="journal-page">
      <Seo pageKey="journal" path="/journal" />
      <PageHero overline={t("journal.heroOverline")} title={t("journal.title")} intro={t("journal.intro")} image={IMG.journal} />

      <section className="relative pb-24">
        <div className="mx-auto max-w-[1400px] px-6 md:px-10">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-px bg-white/10 border border-white/10">
            {categories.map((c, i) => (
              <Reveal key={i} delay={i * 0.05} className="group relative bg-kenosis-black p-8 md:p-10 min-h-[220px] flex flex-col justify-between transition-colors duration-500 hover:bg-kenosis-surface">
                <span className="font-serif text-2xl text-kenosis-gold/40">{String(i + 1).padStart(2, "0")}</span>
                <div>
                  <h3 className="font-serif text-2xl font-normal text-kenosis-ivory">{c.title}</h3>
                  <p className="mt-3 font-sans text-sm font-light text-kenosis-muted">{c.desc}</p>
                  <p className="mt-6 font-sans text-[0.6rem] uppercase tracking-[0.25em] text-kenosis-gold/70">{t("journal.comingSoon")}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <CtaBand />
    </div>
  );
}
